import styled from 'styled-components'

export const InfoBox = styled.div`
  background-color: #fff;
  border-left: 4px solid #4caf50;
  padding: 1rem;
  margin-top: -1rem;
  font-size: 1rem;
  line-height: 1.5;

  @media (max-width: 1024px) {
    padding: 0.75rem;
    font-size: 0.9rem;
  }
`

export const WarningBox = styled.div`
  background-color: #f9f9f9;
  border-left: 4px solid #ef0606;
  padding: 10px;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 4px;

  @media (max-width: 1024px) {
    padding: 0.75rem;
    font-size: 0.9rem;
  }
`

export const Box = styled.div`
  display: flex;
  align-items: center;
  margin: 1rem 0;
`

export const Divider = styled.div`
  flex: 1;
  height: 1px;
  background-color: #e0e0e0;
  margin: 0 1rem;
`

export const FormScrollWrapper = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;

  @media (max-width: 1024px) {
    height: 100vh;
    height: 100dvh;
  }
`

export const ScrollableWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  background-color: ${({ theme }) => theme.palette.grey[100]};
  padding: 1rem;
  margin: 0;

  @media (max-width: 1024px) {
    padding: 0.75rem;
    padding-bottom: 100px;
    height: 100%;
  }
`

export const FullScreenCard = styled.div`
  max-width: 800px;
  margin: 2rem auto;
  background-color: #fff;
  border-radius: 16px;
  padding: 2rem;
  text-align: left;

  @media (max-width: 1024px) {
    margin: 0.5rem;
    padding: 1.25rem 1rem;
    border-radius: 12px;
    max-width: calc(100% - 1rem);
  }
`

export const PageContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 1rem auto;
  gap: 2rem;
  display: flex;
  flex-direction: column;

  @media (max-width: 1024px) {
    gap: 1rem;
    margin: 0;
    padding-bottom: 80px;
  }
`

export const StepCard = styled.div`
  background-color: #fff;
  border-radius: 16px;
  padding: 2rem;
  width: 100%;
  text-align: left;

  @media (max-width: 1024px) {
    padding: 1rem;
    border-radius: 12px;
  }
`

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  @media (max-width: 1024px) {
    gap: 0.75rem;
  }
`

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
  margin-bottom: 12px;

  & > * {
    flex: 1;
    min-width: 250px;
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 0.75rem;
    margin-bottom: 0.75rem;

    & > * {
      min-width: 100%;
      width: 100%;
    }
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  margin-top: 1.5rem;
  gap: 1rem;

  @media (max-width: 1024px) {
    margin-top: 2rem;
    margin-bottom: 1rem;
    justify-content: center;

    button {
      width: 100%;
      max-width: 400px;
    }
  }
`

export const CheckboxGroup = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
`

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  padding: 0.25rem;

  @media (max-width: 1024px) {
    padding: 0.5rem;
    width: 100%;

    input[type='checkbox'] {
      width: 18px;
      height: 18px;
    }
  }
`

export const StepIndicator = styled.div`
  display: inline-flex;
  background-color: ${({ theme }) =>
    theme?.palette?.primary?.main || '#007BFF'};
  color: ${({ theme }) => theme?.palette?.common?.white || '#ffffff'};
  border-radius: 4px;
  width: 25px;
  height: 25px;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  font-weight: bold;
  margin-right: 0.5rem;
  flex-shrink: 0;
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;

  @media (max-width: 1024px) {
    margin-bottom: 1rem;

    h2,
    h3 {
      font-size: 1.25rem;
    }
  }
`

export const MobileInputWrapper = styled.div`
  @media (max-width: 1024px) {
    position: relative;
    width: 100%;

    input:focus {
      position: relative;
      z-index: 1;
    }
  }
`
